// Static kitchen product catalog removed — products come from WooCommerce (dynamic REST).

export const kitchenLayouts = [];
